<template>
  <div class="footer-box">
    <span v-if="type === '1'" style="font-size: 12px;color: #4A4A4A">审批号：PP-GADA-CN-0149-1</span>
    <span v-else style="font-size: 12px;color: #4A4A4A">审批号：PP-GADA-CN-0133-1</span>
  </div>
</template>

<script>
export default {
  name: "footer",
  props: {
    type: String
  }
}
</script>

<style scoped>
.footer-box {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  background: #FFFFFF;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  padding: 10px 0;
}
</style>
